import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";

import SubmissionRanking from "./SubmissionRanking";
import MaturityScore from "./MaturityScore";
import Demographics from "./Demographics";

const GlobalReportsPage = () => {
   const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div className="indi-global-reports-page-container">
      <div className="indi-global-reports-header">
        <h5 className="indi-global-reports-page-title">
          Global Reports Dashboard
        </h5>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="indi-global-reports-tabs"
        >
          <Tab eventKey="tab1" title="Submission Ranking" />
          <Tab eventKey="tab2" title="Maturity Score" />
          <Tab eventKey="tab3" title="Demographics" />
        </Tabs>
      </div>

      <div className="indi-global-reports-body">
        {activeTab === "tab1" && <SubmissionRanking />}
        {activeTab === "tab2" && <MaturityScore />}
        {activeTab === "tab3" && <Demographics />}
      </div>
    </div>
  );
};

export default GlobalReportsPage;
